'use client';

import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useState
} from 'react';

import { useFirstInteraction } from '@/hooks/useFirstInteraction';

type BannerLoadContextProps = {
  canLoadPageTopBanner: boolean;
};

const BannerLoadContext = createContext<BannerLoadContextProps | undefined>(
  undefined
);

export const useBannerLoad = () => {
  const context = useContext(BannerLoadContext);
  if (!context) {
    throw new Error('useBannerLoad must be used within BannerLoadProvider');
  }
  return context;
};

export const BannerLoadProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [canLoadPageTopBanner, setCanLoadPageTopBanner] = useState(false);

  const handleFirstInteraction = useCallback(() => {
    setCanLoadPageTopBanner(true);
  }, []);

  useFirstInteraction(handleFirstInteraction);

  return (
    <BannerLoadContext.Provider value={{ canLoadPageTopBanner }}>
      {children}
    </BannerLoadContext.Provider>
  );
};
